import { render, staticRenderFns } from "./trPL.vue?vue&type=template&id=6cb83a52&scoped=true"
import script from "./trPL.vue?vue&type=script&lang=js"
export * from "./trPL.vue?vue&type=script&lang=js"
import style0 from "./trPL.vue?vue&type=style&index=0&id=6cb83a52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb83a52",
  null
  
)

export default component.exports